import React, { useEffect, useState } from 'react'
import { Table } from "antd";
import { useDispatch, } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { CSVLink } from "react-csv"
import axios from 'axios';
import { adminMainUrl } from '../../../../Config';
import { useFormik } from 'formik';

const ShiplineImport = ({ accessedPermission }) => {

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    useEffect(() => {
        if (token && user_id) {

        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);



    const [dataSource, setDataSource] = useState([]);
    const columns = [
        { title: "S. No.", dataIndex: "SNo", key: "SNo" },
        { title: "Reason", dataIndex: "reason", key: "reason" },
        { title: "Shipline Name", dataIndex: "name", key: "name" },
        { title: "SCAC", dataIndex: "scac", key: "scac" },
        { title: "BIC", dataIndex: "bic", key: "bic" },
        { title: "Alias", dataIndex: "alias", key: "alias" },
        { title: "NVOCC", dataIndex: "is_nvocc", key: "is_nvocc" },
    ];





    //search functionality
    let initialValues = {
        exp_file: "",
    };


    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showRejected, setShowRejected] = useState(false);
    const [rejArr, setRejArr] = useState([]);

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            if (values.exp_file) {
                if (values.exp_file.type !== "text/csv") {
                    toast.error("Please enter a valid csv file.");
                } else {
                    try {
                        setDisableSubmit(true);
                        const formData = new FormData();
                        formData.append("exp_file", values.exp_file);
                        let config = { headers: { "auth-token": token, "user_id": user_id, 'content-type': 'multipart/form-data', } }
                        axios.post(`${adminMainUrl}/api/master/shipline/bulk-import`, formData, config)
                            .then(res => {
                                // console.log(res);
                                if (res.status == 200) {
                                    toast.success("Import successful.");
                                    setDisableSubmit(false);
                                    setShowRejected(false);
                                    setDataSource([]);
                                    navigate(`/flexichain/shipline`);
                                } else {
                                    toast.error(res.data.data.msg)
                                }
                            }).catch(error => {
                                console.log(error);
                                let message = "Internal server error. Please retry!"
                                if (error && error.response && error.response.data) {
                                    // console.log(error.response);
                                    if (error.response.data.msg) {
                                        message = error.response.data.msg
                                    }

                                    if (error.response.data.rejectedRows && error.response.data.rejectedRows.length) {
                                        setShowRejected(true);
                                        setRejArr(error.response.data.rejectedRows)
                                    } else {
                                        setShowRejected(false);
                                    }
                                }

                                toast.error(message);
                                setDisableSubmit(false);
                            })
                    } catch (error) {
                        console.log(error);
                        toast.error(error.message);
                        setDisableSubmit(false);
                    }

                }
            } else {
                toast.error("Couldn't find file.")
            }
        }
    });

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the first file
        if (file) {
            if (file.type == "text/csv") {
                formik.setFieldValue('exp_file', file); // Set the preview URL
            } else {
                toast.error("Please upload a valid CSV file");
            }
        }
    };

    useEffect(() => {
        if (rejArr) {
            let arr = [];
            rejArr.map((val, i) => {
                arr.push({
                    key: i,
                    SNo: i + 1,
                    reason: val.reason,
                    name: val.name,
                    scac: val.scac,
                    bic: val.bic,
                    alias: val.alias,
                    is_nvocc: val.is_nvocc,
                })
            });

            setDataSource(arr);
        }
    }, [rejArr]);


    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row align-items-center">
                                    <div className="col-8">
                                        <h4 className="page-title">
                                            Import Shipline
                                        </h4>
                                    </div>

                                </div>
                            </div>
                            {/* /Page Header */}
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header">
                            <form onSubmit={formik.handleSubmit} encType='multipart/form-data'>
                                <div className="row align-items-center">
                                    <div className="col-sm-4">
                                        <div className="mb-3 mb-sm-0">
                                            <input
                                                type="file"
                                                className="form-control"
                                                // placeholder="Search "
                                                name='exp_file'
                                                // accept="image/*" // Ensure only image files are selected
                                                onChange={handleFileChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                            <button type='submit' className="btn btn-primary me-2" disabled={disableSubmit}>
                                                {
                                                    disableSubmit ?
                                                        <>
                                                            <i className="fas fa-spinner fa-spin"></i> Uploading...
                                                        </>
                                                        :
                                                        "Upload File"
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="card-body">
                            {
                                showRejected &&
                                <>
                                    <div className="d-flex justify-content-between">
                                        <div className=''>
                                            <h4>Errors</h4>
                                        </div>
                                        <div className=''>
                                            {/* <button className="btn btn-sm btn-primary" onClick={handleExportErrors}>Export Errors</button> */}
                                            <CSVLink data={dataSource}>
                                                <button className="btn btn-sm btn-primary">Export Errors</button>
                                            </CSVLink>
                                        </div>
                                    </div>
                                    <div className="table-responsive custom-table">
                                        <Table className="table datanew dataTable no-footer" pagination={false}
                                            dataSource={dataSource} columns={columns} />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ShiplineImport